import stepperClasses from "@mui/material/Stepper/stepperClasses";
export const MuiStepperTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                alignItems: "flex-start",
                position: "relative",
                zIndex: 0,
                [`.${stepperClasses.alternativeLabel}`]: {
                    textAlign: "left",
                },
                "&::after": {
                    content: "''",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: -1,
                    borderTop: `${dt.borderWidth.small} dashed ${dt.color.outlineVariant}`,
                    width: "100%",
                    height: 0,
                },
            },
        },
    };
};
